import React from 'react';
import './AboutTab.css';
import rulesIcon from '../../assets/icons/rules.svg';
import questionsIcon from '../../assets/icons/questions.svg';
import supportIcon from '../../assets/icons/support.svg';
import angleRightIcon from '../../assets/icons/angle-right.svg';
import FAQ from '../FAQ';

const AboutTab = ({ appData, activeScreen, onActiveScreenChange }) => {
  const handleLinkClick = (screen) => {
    if (screen === 'support') {
      // Открываем внешнюю ссылку в новой вкладке
      const supportLink = appData?.configs?.support_link;
      if (supportLink) {
        window.open(supportLink, '_blank', 'noopener,noreferrer');
      }
    } else {
      // Открываем внутренний экран
      onActiveScreenChange(screen);
    }
  };

  // Если открыт внутренний экран, показываем его
  if (activeScreen) {
    return (
      <div className="about-tab">
        <div className="section-header">
          <h2>{activeScreen === 'rules' ? 'Правила сообщества' : 'Вопросы'}</h2>
        </div>
        <div className="screen-content">
          {activeScreen === 'rules' && (
            <div className="rules-content">
              {appData?.configs?.rules_html ? (
                <div 
                  dangerouslySetInnerHTML={{ 
                    __html: appData.configs.rules_html 
                  }} 
                />
              ) : (
                <div>
                  <h3>Правила сообщества</h3>
                  <p>Здесь будут размещены правила сообщества</p>
                </div>
              )}
            </div>
          )}
          {activeScreen === 'questions' && <FAQ appData={appData} />}
        </div>
      </div>
    );
  }

  // Основной экран с тремя ссылками
  return (
    <div className="about-tab">
      <div className="section-header">
        <h2>О нас</h2>
      </div>
      <div className="about-links">
        <div className="about-link" onClick={() => handleLinkClick('rules')}>
          <div className="link-icon">
            <img src={rulesIcon} alt="Правила" />
          </div>
          <div className="link-text">Правила сообщества</div>
          <div className="link-arrow">
            <img src={angleRightIcon} alt="Перейти" />
          </div>
        </div>

        <div className="about-link" onClick={() => handleLinkClick('questions')}>
          <div className="link-icon">
            <img src={questionsIcon} alt="Вопросы" />
          </div>
          <div className="link-text">Вопросы</div>
          <div className="link-arrow">
            <img src={angleRightIcon} alt="Перейти" />
          </div>
        </div>

        <div className="about-link" onClick={() => handleLinkClick('support')}>
          <div className="link-icon">
            <img src={supportIcon} alt="Поддержка" />
          </div>
          <div className="link-text">Служба поддержки</div>
          <div className="link-arrow">
            <img src={angleRightIcon} alt="Перейти" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutTab; 